console.log("🚨 tabs_controller.js is being imported")

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    console.log("✅ Tabs controller connected")
    this.select(null, 0) // Default to first tab
  }

  select(event, index = null) {
    if (event) index = parseInt(event.currentTarget.dataset.tabsIndex)

    this.tabTargets.forEach((tab, i) => {
      const isActive = i === index
      tab.dataset.tabsActiveClass.split(" ").forEach(cls => {
        tab.classList.toggle(cls, isActive)
      })
      tab.dataset.tabsInactiveClass.split(" ").forEach(cls => {
        tab.classList.toggle(cls, !isActive)
      })
    })

    this.panelTargets.forEach((panel) => {
      const panelIndex = parseInt(panel.dataset.tabsIndex)
      panel.classList.toggle("hidden", panelIndex !== index)
    })
  }
}

